var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDropUp48Line = function SvgIconArrowDropUp48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.799 29.43h-9.6a2.9 2.9 0 0 1-2.1-4.9l4.8-5.06a2.91 2.91 0 0 1 4.21 0l4.79 5.06a2.9 2.9 0 0 1-2.1 4.9Zm-8.43-3.4h7.27l-3.64-3.83-3.63 3.83Z",
    fill: "current"
  })));
};
export default SvgIconArrowDropUp48Line;